export enum PRFLSATypes {
	//TABLE PR_Ref_FLSA

	Overtime = 1,
	Exempt = 2,
	CompTime = 3,
}
